var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSearch)?_c('rules-list'):_c('search-page')}
var staticRenderFns = []

export { render, staticRenderFns }